(function ($, window) {
  let $tabMediaFilters = $('.mcl-projects-filters');
  if ($tabMediaFilters.length > 0) {

  }
})
(jQuery, window);
